export default __webpack_public_path__ + "static/media/template.ab83056e.docx";